import { useCallback, useEffect, useState } from "react"
import Link from "next/link"
import Hamburger from "hamburger-react"
import SearchInput from "./search-input"
import validator from "validator"
import { useRouter } from "next/router"

function Menu() {
  const router = useRouter()

  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isSearchOpen, setIsSearchOpen] = useState(false)
  const [isMenuSearchOpen, setIsMenuSearchOpen] = useState(false)

  const [searchQuery, setSearchQuery] = useState("")
  const [searchResults, setSearchResults] = useState([])

  const escFunction = useCallback(event => {
    if (event.key === "Escape") {
      setIsSearchOpen(false)
      setIsMenuSearchOpen(false)
      setIsMenuOpen(false)
    }
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => {
      ;(async () => {
        const response = await fetch(`/api/properties${validator.isEmpty(searchQuery) ? "" : `?area=${searchQuery}`}`)

        if (response.ok) {
          const body = await response.json()

          setSearchResults(body)
        }
      })()
    }, 100)

    return () => clearTimeout(timeout)
  }, [searchQuery, isSearchOpen, isMenuSearchOpen])

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false)

    return () => {
      document.removeEventListener("keydown", escFunction, false)
    }
  }, [escFunction])

  return (
    <div className="overflow-hidden max-w-screen">
      <div
        className={[
          "bg-transparent fixed z-30 top-0 bottom-0 left-0 right-0 transition-all duration-300 backdrop-blur-sm",
          isMenuOpen ? "opacity-100 visible cursor-pointer pointer-events-auto" : "opacity-0 pointer-events-none",
        ].join(" ")}
        onClick={() => {
          setIsMenuOpen(false)
          document?.body?.classList?.remove("overflow-hidden")
        }}
      />
      <div
        className={[
          "fixed bottom-0 left-0 right-0 flex flex-col m-4 overflow-hidden rounded sm:top-0 sm:bottom-auto shadow-neutral-900 z-20 pointer-events-none",
          isMenuOpen ? "z-30" : "",
          isMenuOpen && isMenuSearchOpen ? "h-full justify-end" : "",
        ].join(" ")}
        style={{ filter: `drop-shadow(0 0 25px rgb(0 0 0 / 0.375))` }}
      >
        <div className="absolute opacity-0 top-4 left-4">
          <h2 className="text-stone-900 text-md">Estate Agents in Loughborough</h2>
          <p className="mt-1 text-sm text-stone-500">
            We are here to provide a straightforward, ethical and innovative sales and lettings service in a professional
            environment with a committed and caring team.
          </p>
        </div>
        <div className="absolute opacity-0 top-4 right-4">
          <h2 className="text-stone-900 text-md">Lettings Agents in Loughborough</h2>
          <p className="mt-1 text-sm text-stone-500">
            We are here to provide a straightforward, ethical and innovative sales and lettings service in a professional
            environment with a committed and caring team.
          </p>
        </div>
        <div
          className={[
            isMenuOpen ? "mt-8 mb-4" : "mb-0",
            isMenuOpen && isMenuSearchOpen
              ? "transition-all duration-300 ease-out max-h-full h-full overflow-y-scroll no-scrollbar"
              : "transition-all duration-300 ease-out max-h-[31.625rem] h-fit",
          ].join(" ")}
        >
          <div
            className={[
              "w-full bg-cpink sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl 2xl:max-w-screen-2xl mx-auto sm:hidden rounded overflow-scroll no-scrollbar",
              isMenuOpen
                ? "transition-all translate-y-0 duration-300 pointer-events-auto"
                : "translate-y-full transition-all ease-out duration-300 sm:hidden max-h-0 opacity-0 pointer-events-none",
              isMenuOpen && isMenuSearchOpen ? "max-h-full h-full" : "",
              isMenuOpen || isMenuSearchOpen ? "" : "opacity-100",
            ].join(" ")}
          >
            <div>
              <div
                className="sticky top-0 overflow-hidden bg-white border-b border-stone-900"
                onClick={() => {
                  setIsMenuSearchOpen(true)
                  document?.body?.classList?.add("overflow-hidden")
                }}
              >
                <SearchInput
                  setIsSearchOpen={setIsMenuSearchOpen}
                  isSearchOpen={isMenuSearchOpen}
                  searchQuery={searchQuery}
                  setSearchQuery={setSearchQuery}
                />
              </div>
              <div
                className={[
                  "flex flex-col text-lg leading-none text-stone-900 overflow-scroll no-scrollbar",
                  isMenuOpen && isMenuSearchOpen ? "hidden" : "",
                ].join(" ")}
              >
                {/* <Link
                  prefetch={false}
                  href="/buy"
                  onClick={() => {
                    document?.body?.classList?.remove("overflow-hidden")
                    if (router?.pathname === "/buy") {
                      router.reload("/buy")
                    }
                  }}
                  className={["px-4 border-b py-5 border-stone-900 hover:bg-cpink-50 flex justify-between items-center"].join(
                    " "
                  )}
                >
                  <p>BUY</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </Link> */}
                <Link
                  prefetch={false}
                  onClick={() => {
                    document?.body?.classList?.remove("overflow-hidden")
                    if (router?.pathname === "/rent") {
                      router.reload("/rent")
                    }
                  }}
                  href="/rent"
                  className={["px-4 border-b py-5 border-stone-900 hover:bg-cpink-50 flex justify-between items-center"].join(
                    " "
                  )}
                >
                  <p>PROPERTIES</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </Link>
                {/* <Link
                  prefetch={false}
                  onClick={() => document?.body?.classList?.remove("overflow-hidden")}
                  href="/valuation?type=sell"
                  className={["px-4 border-b py-5 border-stone-900 hover:bg-cpink-50 flex justify-between items-center"].join(
                    " "
                  )}
                >
                  <p>SELL</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </Link> */}
                <Link
                  prefetch={false}
                  onClick={() => document?.body?.classList?.remove("overflow-hidden")}
                  href="/landlords"
                  className={["px-4 border-b py-5 border-stone-900 hover:bg-cpink-50 flex justify-between items-center"].join(
                    " "
                  )}
                >
                  <p>LANDLORDS</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </Link>
                <Link
                  prefetch={false}
                  onClick={() => document?.body?.classList?.remove("overflow-hidden")}
                  href="/contact"
                  className={["px-4 border-b py-5 border-stone-900 hover:bg-cpink-50 flex justify-between items-center"].join(
                    " "
                  )}
                >
                  <p>CONTACT</p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="w-5 h-5"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                </Link>
                {/* <Link
                  prefetch={false}
                  href="tel:+4401509320153"
                  className={[
                    "px-4 border-b border-stone-900 py-5 bg-cpink-200 hover:bg-stone-300 flex justify-between items-center",
                  ].join(" ")}
                >
                  <p>SALES</p>
                  <p>01509 320 153</p>
                </Link> */}
                <Link
                  prefetch={false}
                  href="tel:+4401509320320"
                  className={["px-4 py-5 bg-cpink-200 hover:bg-stone-300 flex justify-between items-center"].join(" ")}
                >
                  <p>LETTINGS</p>
                  <p>01509 320 320</p>
                </Link>
              </div>
              {isMenuSearchOpen && searchResults?.areas?.length !== 0 && (
                <div className="px-4 py-3 text-sm text-white bg-teal-900">
                  {validator.isEmpty(searchQuery) ? "Popular Areas" : "Areas"}
                </div>
              )}
              {isMenuSearchOpen && (
                <div>
                  {searchResults?.areas?.map((result, index) => (
                    <Link
                      className={["pointer-events-auto transition-all duration-300"].join(" ")}
                      href={`/${result.type === "for_sale" ? "buy" : "rent"}?area=${result.area}`}
                      key={index}
                      prefetch={false}
                      onClick={() => document?.body?.classList.remove("overflow-hidden")}
                    >
                      <div className="flex items-center justify-between p-4 bg-transparent border-b border-stone-900 text-stone-900 hover:bg-cpink-50">
                        <div>
                          <p className="text-sm">{result.type === "for_sale" ? "Buy in" : "Rent in"}</p>
                          <p className="font-medium leading-tight">{result.area}</p>
                        </div>
                        <p className="text-right">{`${result.count} ${result.count > 1 ? "properties" : "property"}`}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
              {isMenuSearchOpen && searchResults?.properties?.length > 0 && (
                <>
                  <div>
                    <div className="px-4 py-3 text-sm text-white bg-teal-900">Properties</div>
                  </div>
                  {searchResults?.properties?.map((result, index) => (
                    <Link
                      className={["pointer-events-auto transition-all duration-300"].join(" ")}
                      href={`/${result.type === "for_sale" ? "buy" : "rent"}/${result.id}`}
                      key={index}
                      prefetch={false}
                      onClick={() => {
                        setIsMenuSearchOpen(false)
                        setIsMenuOpen(false)
                        document?.body?.classList?.remove("overflow-hidden")
                      }}
                    >
                      <div className="flex items-center justify-between p-4 bg-transparent border-b border-stone-900 text-stone-900 hover:bg-cpink-50">
                        <div>
                          <p className="text-sm">{result.area}</p>
                          <p className="font-medium leading-tight">{result.address}</p>
                        </div>
                        <div className="text-right">
                          <p className="font-medium text-md">
                            {new Intl.NumberFormat("en-GB", {
                              style: "currency",
                              currency: "GBP",
                              maximumFractionDigits: 0,
                            }).format(result?.price)}
                          </p>
                          <p className="text-sm">
                            {result?.beds} {result?.beds === 1 ? "bed" : "beds"} • {result.baths}{" "}
                            {result?.baths === 1 ? "bath" : "baths"}
                          </p>
                        </div>
                      </div>
                    </Link>
                  ))}
                </>
              )}
            </div>
          </div>
        </div>
        <div
          className={[
            `flex items-center relative z-50 mx-auto sm:max-w-[calc(640px+128px)] md:max-w-[calc(768px+128px)] lg:max-w-[calc(1024px+128px)] xl:max-w-[calc(1280px+128px)] justify-between p-2 rounded 2xl:max-w-[calc(1536px+128px)] w-full transition-all duration-300 bg-teal-900`,
            isMenuOpen ? "sm:shadow-sm" : "mt-auto",
            isSearchOpen ? "hidden sm:flex" : "",
          ].join(" ")}
        >
          <div className="relative z-50 block">
            <Link
              prefetch={false}
              href="/"
              aria-label="Huntleys Estate Agents in Loughborough"
              className="block ml-2 -mb-1 pointer-events-auto"
            >
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 230 52" className="h-6">
                <path
                  fill="#fff"
                  d="M26.235 34.235V23.529H13.176v10.706l3.883 3.53v1.294H0v-1.295l3.882-3.529V8.588L0 5.058V3.766h17.059V5.06l-3.883 3.53v11.176h13.06V8.588l-3.883-3.53V3.766H39.41V5.06l-3.882 3.53v25.646l3.882 3.53v1.294H22.235v-1.295l4-3.529zM44.823 18.47l-3.176-2.352v-1.294L53.41 12v15.53c0 1.882.353 3.293.941 4.235.589.823 1.647 1.294 3.059 1.294 1.176 0 2.588-.353 4.118-.941V18.47l-3.177-2.353v-1.294L70.117 12v22.117l4.235 1.648v1.294l-9.294 2.706-3.53-4.706c-.94 1.411-2 2.47-3.411 3.294-1.412.823-2.941 1.176-4.588 1.176-2.706 0-4.824-.823-6.353-2.47-1.647-1.647-2.47-3.883-2.47-6.706V18.47h.117zm52.235 16.706V24c0-3.647-1.294-5.53-3.882-5.53-1.647 0-3.177.471-4.706 1.412v15.294l2.942 2.588v1.295H76.588v-1.294l3.176-2.589v-16.47l-3.411-2.47V14.94L86 11.882l1.647 4.824c1.411-1.53 2.941-2.706 4.47-3.53 1.53-.823 3.177-1.176 5.06-1.176 2.587 0 4.705.823 6.234 2.47 1.529 1.648 2.353 3.883 2.353 6.706v14.118L108.94 38v1.294H94.117V38l2.941-2.824zm26.118-29.411v6.588h7.058v3.764h-7.058v14c0 1.883.353 3.177.941 3.883s1.647 1.059 2.941 1.059c1.412 0 2.824-.118 3.882-.471v1.294c-.47.47-1.176 1.059-2.235 1.647-.941.588-2.117 1.177-3.412 1.53-1.293.352-2.588.588-3.764.588-2.236 0-4-.588-5.294-2-1.294-1.294-1.883-3.177-1.883-5.53v-16h-4.118v-2.47l4.118-.588V7.765l8.824-2zm13.175 29.411V6.471l-3.176-2.353V2.824L144.94 0v35.176l3.176 2.588v1.294h-14.941v-1.294l3.176-2.588zm39.765-9.882h-15.647c.118 2 .471 3.647.942 4.941.471 1.412 1.412 2.47 2.588 3.294 1.177.824 2.941 1.294 5.177 1.294 1.764 0 3.764-.353 5.882-1.176l.823 1.647c-1.176 1.294-2.706 2.235-4.588 3.059-1.882.823-3.882 1.176-6.235 1.176-4.353 0-7.765-1.176-10.236-3.53-2.47-2.352-3.646-5.646-3.646-9.882 0-1.882.352-3.647.941-5.411a11.568 11.568 0 012.823-4.588c1.177-1.294 2.706-2.353 4.471-3.177 1.765-.823 3.647-1.176 5.647-1.176 1.294 0 2.588.117 3.882.47 1.295.353 2.471.941 3.647 1.883 1.059.823 2 2 2.706 3.411.706 1.412 1.059 3.06 1.059 5.059.117.941 0 1.765-.236 2.706zM164.822 16c-.588 0-1.176.235-1.882.588-.706.47-1.176 1.177-1.647 2.235-.47 1.06-.706 2.353-.824 3.765l8.235-1.059c-.116-1.882-.588-3.294-1.176-4.235-.588-.823-1.529-1.294-2.706-1.294zm17.177 36l-2.352-7.647c.235 0 1.059-.118 2.588-.236 1.529-.117 2.823-.352 3.764-.705 1.059-.353 2.001-.824 2.824-1.647.824-.706 1.647-1.648 2.235-2.706l-10.47-22.706-3.176-2.588V12.47h15.647v1.294l-3.177 2.588 5.294 12.941 4.823-12.941-3.176-2.588V12.47h10.823v1.294l-3.411 2.588-9.412 22.823c-1.53 3.648-2.706 6.236-3.647 7.647-.941 1.412-2.117 2.589-3.53 3.412-1.411.824-3.294 1.412-5.647 1.765zm47.882-21.059c0 2.824-1.059 4.941-3.176 6.47-2.118 1.412-5.059 2.236-8.824 2.236-1.294 0-2.588-.118-3.882-.236-1.294-.117-2.941-.588-4.706-1.058v-8.824h1.295l4.117 6.118c.824.235 1.646.47 2.235.47 3.059 0 4.706-.94 4.706-2.705 0-.471-.236-1.06-.706-1.647-.47-.589-1.765-1.412-3.882-2.353-2.236-.941-3.765-1.883-4.706-2.706-.941-.824-1.648-1.647-2.118-2.706-.471-1.059-.706-2.235-.706-3.53 0-2.47.942-4.588 2.941-6.117 2.001-1.53 4.707-2.353 8.236-2.353 2.588 0 4.941.47 7.293 1.53v7.764h-1.293l-3.882-5.53c-2.001 0-3.294.236-3.883.707-.706.47-.941 1.176-.941 2 0 .352.117.705.235 1.058.235.353.471.706.941 1.06.471.352 1.883 1.058 4.353 2.235 2.471 1.176 4.236 2.352 5.059 3.646.824 1.295 1.294 2.706 1.294 4.471z"
                ></path>
              </svg>
            </Link>
          </div>
          <button
            aria-label="menu"
            className="rounded pointer-events-auto hover:bg-teal-800 sm:hidden"
            onClick={() => {
              setIsMenuSearchOpen(false)
              setIsMenuOpen(isMenuOpen => !isMenuOpen)
              isMenuOpen
                ? document?.body?.classList?.remove("overflow-hidden")
                : document?.body?.classList?.add("overflow-hidden")
            }}
          >
            <Hamburger toggled={isMenuOpen} color="#fff" direction="sm" size={18} label="menu" />
          </button>
          <div className="hidden sm:flex gap-x-4">
            {/* <Link
              prefetch={false}
              href="/buy"
              onClick={() => {
                document?.body?.classList?.remove("overflow-hidden")
                if (router?.pathname === "/buy") {
                  router.reload("/buy")
                }
              }}
              className="hidden px-3 py-2 text-center text-white transition-all duration-300 rounded pointer-events-auto hover:bg-teal-800 sm:block"
            >
              Buy
            </Link> */}
            <Link
              prefetch={false}
              href="/rent"
              onClick={() => {
                document?.body?.classList?.remove("overflow-hidden")
                if (router?.pathname === "/rent") {
                  router.reload("/rent")
                }
              }}
              className="hidden px-3 py-2 text-center text-white transition-all duration-300 rounded pointer-events-auto hover:bg-teal-800 sm:block"
            >
              Properties
            </Link>
            <Link
              prefetch={false}
              href="/landlords"
              onClick={() => document?.body?.classList?.remove("overflow-hidden")}
              className="hidden px-3 py-2 text-center text-white transition-all duration-300 rounded pointer-events-auto hover:bg-teal-800 sm:block"
            >
              Landlords
            </Link>
            <Link
              prefetch={false}
              href="/valuation?type=sell"
              onClick={() => document?.body?.classList?.remove("overflow-hidden")}
              className="hidden px-3 py-2 text-center text-white transition-all duration-300 rounded pointer-events-auto hover:bg-teal-800 sm:block"
            >
              Sell
            </Link>
            <Link
              prefetch={false}
              href="/contact"
              onClick={() => document?.body?.classList?.remove("overflow-hidden")}
              className="hidden px-3 py-2 text-center text-white transition-all duration-300 rounded pointer-events-auto hover:bg-teal-800 sm:block"
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Menu

